import { useEffect, useRef, useState } from 'react';
import { fetchCalls } from '../../api';

/**
 * Догрузка полного `CallDetailsItemDto` по идентификатору звонка — для точек входа,
 * у которых на руках только `callId` (примеры звонков за графиком, диплинк по ссылке).
 *
 * Диапазон дат не передаём сознательно: при заданном `call_id` сервер его не применяет
 * (см. `BuildCallsWhereAsync`), поэтому звонок открывается независимо от выбранного периода.
 *
 * `callId = null` сбрасывает состояние — это закрытие карточки.
 */
const useCallDetails = (callId) => {
  const [call, setCall] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Быстрое переключение между строками списка отправляет несколько запросов;
  // без счётчика в карточке оседал бы тот, что вернулся последним, а не последний запрошенный.
  const requestSeq = useRef(0);

  useEffect(() => {
    if (!callId) {
      setCall(null);
      setError(null);
      setIsLoading(false);
      return;
    }

    const seq = ++requestSeq.current;
    setIsLoading(true);
    setError(null);

    fetchCalls({ call_id: callId, limit: 1 })
      .then((response) => {
        if (seq !== requestSeq.current) {
          return;
        }

        const item = response.items?.[0] ?? null;
        setCall(item);
        if (!item) {
          setError('Звонок не найден.');
        }
      })
      .catch((err) => {
        if (seq !== requestSeq.current) {
          return;
        }

        console.error(err);
        setCall(null);
        setError('Не удалось загрузить детали звонка.');
      })
      .finally(() => {
        if (seq === requestSeq.current) {
          setIsLoading(false);
        }
      });
  }, [callId]);

  return { call, isLoading, error };
};

export default useCallDetails;
